<template>
    <div class="date-select">
        <div class="input-fields__header">
            <h3 v-text="translations.birthday_header"></h3>
        </div>
        <div class="input-fields__content">
            <selector :name="this.translations.date_day" v-model="selectedDay" :options="days"
                :icon-type="selectedDay == '-1' ? 'drop-down' : this.checkmarkIcon">
            </selector>
            <selector :name="this.translations.date_month" v-model="selectedMonth" :options="months"
                :icon-type="selectedMonth == '-1' ? 'drop-down' : this.checkmarkIcon"></selector>
            <selector :name="this.translations.date_year" v-model="selectedYear" :options="years"
                :icon-type="selectedYear == '-1' ? 'drop-down' : this.checkmarkIcon"></selector>
        </div>
    </div>
</template>
  
<script>
import Moment from 'moment';
import Selector from './../selector.vue';

export default {
    props: {
        value: {
            type: String,
            default: '',
        },
        format: {
            type: String,
            default: 'DD-MM-YYYY'
        },
        yearsToGoBack: {
            type: Number,
            default: 20
        },
        yearOffset: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            checkmarkIcon: "checkmark",
            selectedDay: "-1",
            selectedMonth: "-1",
            selectedYear: "-1",
            translations: APP_CONFIG.TRANSLATION.SELECT_DATE_PICKER,
        };
    },
    watch: {
        dateMoment() {
            if (this.dateMoment) {
                this.$emit('input', this.dateMoment.format(this.format));
            } else {
                return this.$emit('input', '');
            }
        },
        value() {
            if (this.value) {
                let date = Moment(this.value, this.format);
                if (date) {
                    this.selectedDay = date.format("DD");
                    this.selectedMonth = date.format("MM");
                    this.selectedYear = date.format("YYYY");
                }
            }
        }
    },
    computed: {
        date() {
            if (
                parseInt(this.selectedYear) > 0 &&
                parseInt(this.selectedMonth) > 0 &&
                parseInt(this.selectedDay) > 0
            ) {
                return this.selectedYear + "-" + this.selectedMonth + "-" + this.selectedDay;
            }

            return "";
        },
        dateMoment() {
            console.log(this.date);
            return this.date
                ? Moment(this.date, "YYYY-MM-DD")
                : null;
        },
        days() {
            let days = [{ text: this.translations.date_day, value: "-1" }];
            for (let i = 1; i <= 31; i++) {
                let day = i.toString();

                days.push({
                    value: i.toString().padStart(2, "0"),
                    text: day,
                });
            }

            return days;
        },
        months() {
            return [{ text: this.translations.date_month, value: "-1" }].concat(
                Moment.months().map((val, key) => {
                    let month = key + 1;

                    return {
                        value: month.toString().padStart(2, "0"),
                        text: val,
                    };
                })
            );
        },
        years() {
            let year = Moment().year();
            year = year + this.yearOffset;
            let years = [{ text: this.translations.date_year, value: "-1" }];
            for (let i = 0; i < this.yearsToGoBack; i++) {
                years.push((year - i).toString());
            }

            return years;
        },
    },
    components: {
        Selector
    }
};
</script>